import { fetchJobData, fetchJobsData } from "./actions/fetchActions";
import {
  jobsReducer,
  jobReducer,
  createJobReducer,
  updateJobReducer,
  deleteJobReducer,
} from "./reducers/fetchReducers";

const jobReducers = {
  jobsGlobalStore: jobsReducer,
  jobGlobalStore: jobReducer,
  createJobGlobalStore: createJobReducer,
  updateJobGlobalStore: updateJobReducer,
  deleteJobGlobalStore: deleteJobReducer,
};

export { fetchJobData, fetchJobsData, jobReducers };
